import { TranslationObject } from '../i18n/translation';

const namespace = 'calendarpsa';
const translations: TranslationObject = {
  titlePart1: {
    id: 'calendaruha.titlePart1',
    nb: 'Praksiskalender for',
    en: 'Practice calendar',
  },
  titlePart2: {
    id: 'calendaruha.titlePart2',
    nb: 'Studieåret {year}',
    en: 'Year {year}',
  },
  linkYear: {
    id: 'calendarpsa.linkYear',
    nb: 'Studieår',
    en: 'Year',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Besvar kapasitet for alle praksisaktivitetene i kalenderen under',
    en: 'Register capacity for all practice activities in the calendar below',
  },
  searchbarEmnefilterPlaceholder: {
    id: `${namespace}.searchbar.emnefilter.placeholder`,
    nb: 'Vis alle aktiviteter',
    en: 'See all activities',
  },
  emptyStateTitle: {
    id: 'calendarpsa.emptyStateTitle',
    nb: 'Det er ingen tilgjengelige undervisningsdata for dette studieåret.',
    en: 'There are no data available for this academic year.',
  },
  emptyStateText: {
    id: 'calendarpsa.emptyStateText',
    nb: 'Kontroller at søket ditt er korrekt.',
    en: 'Make sure your filter is correct.',
  },
};

export default translations;
